
    import '/opt/buildhome/repo/packages/x/docs/x-markdown/components-think.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-x-markdown-components-think-demo-think"],
  getter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/x-markdown/components-think.zh-CN.md?type=demo')
};